import { ReactElement } from 'react'
import { AdminConfirmCancellationTemplateProps } from './adminconfirmcancellation.props'
import { Button, Flex, Heading, Text } from '@raskrask-dk/rr-components'
import { BackButton } from '../chemistry'
import { RRDate } from '@raskrask-dk/raskrask-utils'

export const AdminConfirmCancellationTemplate = ({
    canDoCta,
    onClickCta,
    bookingId,
    bookingPayment,
}: AdminConfirmCancellationTemplateProps): ReactElement => {
    const detailedPaymentText = (
        <>
            <Flex direction={'row'} justifyContent={'space-between'}>
                <Text>Total:</Text>
                <Text>{bookingPayment?.total || '-'}</Text>
            </Flex>
            <Flex direction={'row'} justifyContent={'space-between'}>
                <Text>PaymentMethod:</Text>
                <Text>{bookingPayment?.paymentMethod || '-'}</Text>
            </Flex>
            <Flex direction={'row'} justifyContent={'space-between'}>
                <Text>PaymentDate:</Text>
                <Text>
                    {new RRDate(bookingPayment?.datePaid).toString(
                        'd. dd/MM/yy kl. HH.mm'
                    ) || '-'}
                </Text>
            </Flex>
            <Flex direction={'row'} justifyContent={'space-between'}>
                <Text>PaymentNote:</Text>
                <Text>{bookingPayment?.paymentNote || '-'}</Text>
            </Flex>
        </>
    )

    const paidText = (
        <Text>
            The booking is{' '}
            {bookingPayment?.isFullyPaid
                ? 'fully paid'
                : bookingPayment?.paymentMethod
                ? 'not fully paid'
                : 'not paid'}
            .
        </Text>
    )

    const refundText = (
        <>
            {bookingPayment?.canAutoRefund ? (
                <Text>
                    The payments of the booking will be automatically refunded.
                </Text>
            ) : (
                <Text>
                    The payments of the booking can not be automatically
                    refunded. Please let Oskar know about this case.
                </Text>
            )}
        </>
    )

    return (
        <>
            <Flex direction={'row'} justifyContent={'center'}>
                <Flex
                    direction={'column'}
                    gap={16}
                    css={{
                        p: '$4 $3',
                        bgc: '$white',
                        border: '1px solid $neutral200',
                        height: '100%',
                        width: '500px',
                    }}
                >
                    <Heading>Cancel Booking</Heading>

                    <Flex direction={'column'} gap={16}>
                        <Text color={'primary300'}>{bookingId}</Text>
                        {paidText}
                        {detailedPaymentText}
                        {refundText}
                    </Flex>

                    <Flex gap={16} justifyContent={'flex-end'}>
                        <BackButton />
                        <Button
                            variant={'default'}
                            size={'large'}
                            disabled={!canDoCta}
                            onClick={() => onClickCta()}
                        >
                            Confirm
                        </Button>
                    </Flex>
                </Flex>
            </Flex>
        </>
    )
}
